import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";

import WGRTable from "./WGRTable";
import WGRTotals from "./WGRTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {
    return rows.reduce(
      (sum, row) => ({
        primeLabour:
          sum.primeLabour +
          Number(row.PRIMECOST_LABOUR || 0),

        primeStores:
          sum.primeStores +
          Number(row.PRIMECOST_STORES || 0),

        onCostLabour:
          sum.onCostLabour +
          Number(row.ONCOST_LABOUR || 0),

        onCostStores:
          sum.onCostStores +
          Number(row.ONCOST_STORES || 0),

        proforma:
          sum.proforma +
          Number(row.PROFORMA || 0),

        profit:
          sum.profit +
          Number(row.PROFIT || 0),

        supStores:
          sum.supStores +
          Number(row.SUP_STORES || 0),

        freight:
          sum.freight +
          Number(row.FREIGHT || 0),

        incentive:
          sum.incentive +
          Number(row.INCENTIVE || 0),
      }),
      {
        primeLabour: 0,
        primeStores: 0,
        onCostLabour: 0,
        onCostStores: 0,
        proforma: 0,
        profit: 0,
        supStores: 0,
        freight: 0,
        incentive: 0,
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
        >
          Shop Number : {shop}
        </Typography>
      </Box>

      {/* Detail Table */}

      <WGRTable rows={rows} />

      {/* Shop Total */}

      <WGRTotals
        shop={shop}
        totals={totals}
      />
    </Paper>
  );
}

